import { useLocation, useNavigate } from "react-router-dom"
import { CircleHelp } from "lucide-react"
import { Separator } from "@/components/ui/separator"
import { Button } from "@/components/ui/button"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { useAuth } from "@/contexts/AuthContext"
import { requestGuidedTour } from "@/lib/guided-tour"

export function SiteHeader() {
  const navigate = useNavigate()
  const location = useLocation()
  const { recruiter, logout } = useAuth()
  const initialLetter = recruiter?.username?.charAt(0)?.toUpperCase() ?? "?"

  const handleLogout = () => {
    logout()
    navigate("/login")
  }

  return (
    <header className="group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 flex h-12 shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear">
      <div className="flex w-full items-center gap-2 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 h-4"
        />
        <h1 className="text-base font-medium">מערכת גיוס</h1>
        <div className="flex-1" />
        <Button
          variant="outline"
          size="sm"
          data-tour="tour-help"
          onClick={() => {
            requestGuidedTour()
            if (location.pathname !== "/dashboard") navigate("/dashboard")
          }}
        >
          <CircleHelp />
          הדרכה
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className="flex items-center gap-2"
          onClick={handleLogout}
          title="התנתק"
          aria-label="התנתק"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary text-primary-foreground text-sm font-semibold">
            {initialLetter}
          </span>
          <span>התנתק</span>
        </Button>
      </div>
    </header>
  )
}
